// removed by extract-text-webpack-plugin
module.exports = {"base":"cms__ObjectControl__base","container":"cms__ObjectControl__container","rounded":"cms__ObjectControl__rounded","depth":"cms__ObjectControl__depth","clearfix":"cms__ObjectControl__clearfix","root":"cms__ObjectControl__root"};


//////////////////
// WEBPACK FOOTER
// ./components/Widgets/ObjectControl.css
// module id = 591
// module chunks = 0